import {axios} from '@js/utilities/axios.js';

export default {
	namespaced: true,
	state: {
		items: [],
		error: null,
		requestSuccessful: false,
	},
	actions: {
		async fetchItems({commit}, params) {

			return axios.get('/api/announcements', {
				params: params,
			}).then(response => commit('setItems', response.data.data));
		},
		// eslint-disable-next-line no-unused-vars
		async fetchItem({commit}, id) {
			return axios.get('/api/announcements/' + id).then(response => response.data);
		},
		async upsertItem({commit, dispatch}, item) {
			commit('clearRequest');
			if (item.id) {
				return axios.put(`/api/announcements/${item.id}`, item).then(() => {
					dispatch('fetchItems');
					commit('requestSuccessful', true);
				}).catch((error) => {
					commit('requestFailed', error);
				});
			}

			return axios.post('/api/announcements', item).then(() => {
				dispatch('fetchItems');
				commit('requestSuccessful', true);
			}).catch((error) => {
				commit('requestFailed', error);
			});
		},
		async delete({commit, dispatch}, item) {
			commit('clearRequest');
			return axios.delete(`/api/announcements/${item.id}`).then(() => {
				dispatch('fetchItems');
				commit('requestSuccessful', true);
			}).catch((error) => {
				commit('requestFailed', error);
			});
		}
	},
	mutations: {
		setItems(state, items) {
			state.items = items;
		},
		requestSuccessful(state, status) {
			state.requestSuccessful = status;
		},
		requestFailed(state, error) {
			state.error = error;
		},
		clearRequest(state) {
			state.error = null;
			state.requestSuccessful = false;
		}
	},
	getters: {
		items: state => state.items,
		error: state => state.error,
		requestSuccessful: state => state.requestSuccessful,
		requestFailed: state => state.error !== null,
	}
}
